<template>
  <v-container fluid pa-0 ma-0 fill-height>
    <v-layout >
      <v-card :color="cardcolor" height="100%" width="100%" class="ma-0 pa-0 elevation-0">
        <v-card-text class="ma-0 pa-0">
          <span v-if="title !== false" class=" d-block headline white--text mt-4 " :class="[$vuetify.breakpoint.mdAndUp ? 'mb-0' : 'px-5 mb-2']">
            {{ title }}
          </span>
          <slot></slot>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    title: { default: false },
    cardcolor: { default: 'transparent' },
  },
  name: '',
  data() {
    return {};
  },
};
</script>
